module.exports = __webpack_public_path__ + "static/img/backgroud.281e6fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/alipay/backgroud.jpg
// module id = q/1o
// module chunks = 1